<template>
  <div
    v-if="showLoadingState == true"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingProductDetail"
  >
    <div class="m-edition-billing-product-detail-info">
      <div class="m-edition-billing-product-detail-info-left">
        <div class="m-edition-billing-product-detail-info-body">
          <h4>{{ $t('mEditionBillingProductDetail.infoLeft.title') }}</h4>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-box-open"></i>
            </span>
            <span>
              {{  producto.nombre }}
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-text"></i>
            </span>
            <span>
              {{  producto.descripcion }}
            </span>
          </p>
          <P>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-tag"></i>
            </span>
            {{ $t('mEditionBillingProductDetail.infoLeft.tags') }}
            <span
              v-if="producto.etiquetas.length === 0"
              class="margin-left-small"
            >
              Sin Etiquetas
            </span>
            <span
              v-for="(etiqueta, index) in producto.etiquetas"
              :key="index"
            >
              {{ etiqueta + (index === producto.etiquetas.length -1 ? '.' : ', ')}}
            </span>
          </P>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-credit-card"></i>
            </span>
            <span>
              Venta de producto
              <span
                v-if="producto.activo"
                class="font-weight-bold"
              >
                Habilitada
              </span>
              <span
                v-else
                class="font-weight-bold"
              >
                Deshabilitado
              </span>
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-eye"></i>
            </span>
            <span>
              Producto
              <span
                v-if="producto.visible"
                class="font-weight-bold"
              >
                Visible
              </span>
              <span
                v-else
                class="font-weight-bold"
              >
                Oculto
              </span>
              en tienda de academia
            </span>
          </p>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-file-invoice-dollar"></i>
            </span>
            <span>
              {{ $t('mEditionBillingProductDetail.infoLeft.students') + producto.cantidad_ventas }}
            </span>
          </p>
          <p
            v-if="producto.proyectos && producto.proyectos.length"
            style="align-items:baseline !important;"
          >
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-list"></i>
            </span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="padding-bottom: 10px">
                <span class="font-weight-bold">
                  {{ $t('mEditionBillingProductDetail.infoLeft.projects') }}
                </span>
              </li>
              <li
                v-for="(proyecto, index) in producto.proyectos"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
              >
                <span>
                  - {{ proyecto.titulo}}
                </span>
              </li>
            </ul>
          </p>
          <p
            v-if="producto.autoresponders && producto.autoresponders.length"
            style="align-items:baseline !important;"
          >
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-reply-all"></i>
            </span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="padding-bottom: 10px">
                <span class="font-weight-bold">
                  {{ $t('mEditionBillingProductDetail.infoLeft.autoresponders.title') }}
                </span>
              </li>
              <li
                v-for="(autoresponder, index) in producto.autoresponders"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
              >
                <span>
                  - {{ autoresponder.nombre}}, {{ autoresponder.lista }}
                </span>
              </li>
            </ul>
          </p>
          <p v-if="producto.paginas && producto.paginas.length && producto.paginas.some(pagina => pagina.tipo === 0)"
            style="align-items:baseline !important;"
            >
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-handshake"></i>
            </span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="padding-bottom: 10px">
                <span class="font-weight-bold">
                  {{ $t('mEditionBillingProductDetail.infoLeft.pages.gratitude_title') }}
                </span>
              </li>
              <li
                v-for="(pagina, index) in producto.paginas.filter(pagina => pagina.tipo === 0)"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
              >
                <span class="info-text-highlighted-success">
                  - {{ pagina.nombre}}
                </span>
              </li>
            </ul>
          </p>
          <p v-if="producto.paginas && producto.paginas.length && producto.paginas.some(pagina => pagina.tipo === 1)"
            style="align-items:baseline !important;"
            >
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-bullhorn"></i>
            </span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="padding-bottom: 10px">
                <span class="font-weight-bold">
                  {{ $t('mEditionBillingProductDetail.infoLeft.pages.sales_title') }}
                </span>
              </li>
              <li
                v-for="(pagina, index) in producto.paginas.filter(pagina => pagina.tipo === 1)"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
              >
                <span class="info-text-highlighted-success">
                  - {{ pagina.nombre }}
                </span>
              </li>
            </ul>
          </p>
          <p
            v-if="producto.cupon_descuento && producto.cupon_descuento.length && producto.cupon_descuento.some(cupon => cupon.activo === true)"
            style="align-items:baseline !important;"
          >
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-barcode-read"></i>
            </span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="padding-bottom: 10px">
                <span class="font-weight-bold">
                  {{ $t('mEditionBillingProductDetail.infoLeft.discount_coupon') }}
                </span>
              </li>
              <li
                v-for="(cd, index) in producto.cupon_descuento"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
              >
                <span>
                  - {{ cd.codigo}} {{ cd.monto_descuento }}%
                </span>
              </li>
            </ul>
          </p>
          <p
            v-if="producto.codigo_rastreo && producto.codigo_rastreo.length"
            style="align-items:baseline !important;"
          >
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-code"></i>
            </span>
            <ul style="list-style: none; margin: 0; padding: 0;">
              <li style="padding-bottom: 10px">
                <span class="font-weight-bold">
                  {{ $t('mEditionBillingProductDetail.infoLeft.tracking_codes') }}
                </span>
              </li>
              <li
                v-for="(cr, index) in producto.codigo_rastreo"
                :key="index"
                style="font-style: italic; padding-bottom: 5px;"
              >
                <span>
                  - {{ cr.nombre}}
                </span>
              </li>
            </ul>
          </p>
        </div>

        <div
          class="m-edition-billing-product-detail-info-body"
          v-if="producto.pago && producto.gestiones.length"
        >
          <h4>PRECIOS Y PLANES</h4>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-calendar-check"></i>
            </span>
            <span v-if="producto.trial_intervalo !== 0">
              Periodo de prueba de {{ producto.trial_intervalo }} {{ $filters.getFrequencyValue(producto.trial_frecuencia, 'name') }}
            </span>
            <span v-else>
              Sin periodo de prueba
            </span>
          </p>
            <div
              v-for="(gestion, index) in producto.gestiones"
              :key="index"
            >
              <p style="align-items:baseline !important;">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-money-bill-alt"></i>
                </span>
                <ul style="list-style: none; margin: 0; padding: 0;">
                  <li style="padding-bottom: 10px !important;">
                    <span>
                      {{ gestion.divisa.nombre.toUpperCase() }} {{ gestion.divisa.simbolo }} {{ gestion.divisa.iso_code  }}
                    </span>
                  </li>
                  <li style="padding-bottom: 10px !important;">
                    {{ $t('mEditionBillingProductDetail.infoRight1.sell_point') }}
                    <span style="font-style: italic;">
                      {{ gestion.punto_venta.nombre}} - {{ gestion.punto_venta.comprobante_nombre }} - {{ gestion.punto_venta.pais.nombre }}
                    </span>
                  </li>
                <li style="padding-bottom: 10px">
                  <span>
                    {{ $t('mEditionBillingProductDetail.infoRight1.plans.title') }}
                  </span>
                </li>
                <li
                  v-for="(plan, indexP) in gestion.planes"
                  :key="indexP"
                  style="font-style: italic; padding-bottom: 5px;"
                  >
                    - {{ getProductoGestionPlanText(plan, gestion.divisa.simbolo, gestion.divisa.iso_code) }}
                </li>
                <li style="padding-bottom: 10px">
                    {{ $t('mEditionBillingProductDetail.infoRight1.payment_gateway.title') }}
                </li>
                <li
                  v-for="(pasarela, indexM) in gestion.pasarelas"
                  :key="indexM"
                  style="font-style: italic; padding-bottom: 5px;"
                >
                  - {{ pasarela.descripcion}} ({{ pasarela.nombre_publico }})
                </li>
                </ul>
              </p>
          </div>
        </div>

        <div
          class="m-edition-billing-product-detail-info-body"
          v-else
          >
          <h4>{{ $t('mEditionBillingProductDetail.infoRight1.title') }}</h4>
          <p>
            <span class="info-icon-left info-icon-billing">
              <i class="fas fa-info"></i>
            </span>
            <span>
              {{ $t('mEditionBillingProductDetail.infoRight1.pago.false') }}
            </span>
          </p>
        </div>
      </div>

      <div
        class="m-edition-billing-product-detail-info-right"
        >
          <div class="m-edition-billing-product-detail-info-body padding-zero">
            <span>
              <CardDesign2
                v-if="this.producto.tarjeta === 2"
                :producto= producto
              />
              <CardDesign3
                v-if="this.producto.tarjeta === 3"
                :producto= producto
              />
              <CardDesign4
                v-if="this.producto.tarjeta === 4"
                :producto= producto
              />
              <CardDesign5
                v-if="this.producto.tarjeta === 5"
                :producto= producto
              />
              <CardDesign6
                v-if="this.producto.tarjeta === 6"
                :producto= producto
              />
              <CardDesign7
                v-if="this.producto.tarjeta === 7"
                :producto= producto
              />
            </span>
          </div>
          <div
            class="m-edition-billing-product-detail-info-body"
            v-if="producto.maximo_alumnos"
          >
            <h4>{{ $t('mEditionBillingProductDetail.infoRight2.title') }}</h4>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-users"></i>
                </span>
                Maximo alumnos
              </span>
            <span class="info-text-right">
              {{  producto.maximo_alumnos }}
            </span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-folder"></i>
                </span>
                Maximo proyectos
              </span>
              <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-map-marker-alt"></i>
                </span>
                Maximo mapas
              </span>
              <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-box-open"></i>
                </span>
                Maximo productos
              </span>
              <span class="info-text-right">
                <i class="far fa-infinity"></i>
              </span>
            </p>
            <p v-if="false">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-envelope"></i>
                </span>
                Maximo emails
              </span>
              <span class="info-text-right">
                {{  producto.maximo_emails }}
              </span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-file-alt"></i>
                </span>
                  Maximo puntos de venta
              </span>
                <span class="info-text-right">
                  <i class="far fa-infinity"></i>
                </span>
            </p>
            <p v-if="false">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-money-check"></i>
                </span>
                Comisiones
              </span>
              <span class="info-text-right">
                {{  producto.comisiones }}
              </span>
            </p>
            <p v-if="false">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-graduation-cap"></i>
                </span>
                  Universidad Profesional
              </span>
              <span class="info-text-right">
                <span v-if="producto.tipo_universidad" class="font-weight-bold info-text-highlighted-success"> Si </span>
                <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
              </span>
            </p>
            <p>
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-puzzle-piece"></i>
                </span>
                  Integraciones
              </span>
              <span class="info-text-right">
                <span v-if="producto.integraciones" class="font-weight-bold info-text-highlighted-success"> Si </span>
                <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
              </span>
            </p>
            <p v-if="false">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-video"></i>
                </span>
                  Clases en vivo
              </span>
              <span class="info-text-right">
                <span v-if="producto.clases_vivo" class="font-weight-bold info-text-highlighted-success"> Si </span>
                <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
              </span>
            </p>
            <p v-if="false">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-link"></i>
                </span>
                  Afiliaciones
              </span>
              <span class="info-text-right">
                <span v-if="producto.afiliaciones" class="font-weight-bold info-text-highlighted-success"> Si </span>
                <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
              </span>
            </p>
            <p v-if="false">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-file"></i>
                </span>
                  Evaluaciones
              </span>
              <span class="info-text-right">
                <span v-if="producto.evaluaciones" class="font-weight-bold info-text-highlighted-success"> Si </span>
                <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
              </span>
            </p>
            <p v-if="false">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-users"></i>
                </span>
                  Control de alumnos
              </span>
              <span class="info-text-right">
                <span v-if="producto.control_alumnos" class="font-weight-bold info-text-highlighted-success"> Si </span>
                <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
              </span>
            </p>
            <p v-if="false">
              <span class="info-text-left">
                <span class="info-icon-left info-icon-billing">
                  <i class="fas fa-file-import"></i>
                </span>
                  Importacion de alumnos
              </span>
              <span class="info-text-right">
                <span v-if="producto.importacion_alumnos" class="font-weight-bold info-text-highlighted-success"> Si </span>
                <span v-else class="font-weight-bold info-text-highlighted-danger"> No </span>
              </span>
            </p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MoleculeEditionBillingAcademyProductsDetail',

  components: {
    CardDesign2: () => import('@/components/molecules/MoleculeEditionBillingAcademyProductCard2'),
    CardDesign3: () => import('@/components/molecules/MoleculeEditionBillingAcademyProductCard3'),
    CardDesign4: () => import('@/components/molecules/MoleculeEditionBillingAcademyProductCard4'),
    CardDesign5: () => import('@/components/molecules/MoleculeEditionBillingAcademyProductCard5'),
    CardDesign6: () => import('@/components/molecules/MoleculeEditionBillingAcademyProductCard6'),
    CardDesign7: () => import('@/components/molecules/MoleculeEditionBillingAcademyProductCard7')
  },

  data () {
    return {
      producto: {},
      showLoadingState: true
    }
  },
  created () {
    this.readProductos()
  },
  methods: {
    getProductoGestionPlanText (plan, simbolo, isoCode) {
      if (plan.pago.cuotas === 0) {
        return `1 pago de ${simbolo} ${plan.pago.precio} ${isoCode} cada ${plan.pago.intervalo} ${this.$filters.getFrequencyValue(plan.pago.frecuencia, 'name')}`
      } else if (plan.pago.cuotas === 1) {
        return `1 pago de contado de ${simbolo} ${plan.pago.precio} ${isoCode}`
      } else {
        return `${plan.pago.cuotas} cuotas mensuales de ${simbolo} ${plan.pago.precio} ${isoCode}`
      }
    },

    readProductos () {
      this.$services.read('producto', 'readProductoDetalle', {}, [this.$route.params.subid])
        .then(response => {
          console.log(response.data)
          this.producto = response.data
          this.showLoadingState = false
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    }
  }
}
</script>
